import TemplateMetaForm, { TemplateMetaFormProps } from '@anm/components/form/TemplateMetaForm';
import CardModal from '@anm/components/modals/CardModal';
import { ModalProps } from '@anm/components/modals/Modal';
import { FC } from 'react';

import Wrapper, { Title } from './Wrapper';

export type FormValues = {
  slug: string;
  tags: string;
  displayName: string;
  description: string;
};

type TemplateMetaEditModalProps = Omit<ModalProps, 'onSubmit'> &
  TemplateMetaFormProps & {
    initialValues?: FormValues;
  };

const TemplateMetaEditModal: FC<TemplateMetaEditModalProps> = ({ onModalClose, ...formProps }) => (
  <CardModal {...{ onModalClose }}>
    <Wrapper>
      <Title title="Update template" />
      <TemplateMetaForm {...formProps} onCancel={onModalClose} />
    </Wrapper>
  </CardModal>
);

export default TemplateMetaEditModal;
